import Sdk from "@modules/sdk/Sdk";
import { SdkRegisteredModuleInterface } from "@modules/sdk/SdkRegisteredModuleInterface";
import { TokenManagerModule } from "@modules/token_manager/TokenManagerModule";

import { AuthenticationInfoProviderInterface } from "../AuthenticationInfoProvider/AuthenticationInfoProviderInterface";
import { SignedAuthenticator } from "../authenticators/SignedAuthenticator";
import AuthenticationSdkMethods from "./AuthenticationSdkMethods";

class AuthenticationSdk implements SdkRegisteredModuleInterface {
    public readonly methods: AuthenticationSdkMethods;

    constructor(
        tokenManagerModule: TokenManagerModule,
        signedAuthenticator: SignedAuthenticator,
        authenticationInfoProvider: AuthenticationInfoProviderInterface
    ) {
        this.methods = new AuthenticationSdkMethods(
            tokenManagerModule,
            signedAuthenticator,
            authenticationInfoProvider
        );
    }

    public register(sdk: Sdk & { authentication?: AuthenticationSdk }) {
        sdk.authentication = this;
    }
}

export default AuthenticationSdk;
